import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  wishlistBtn: {
    id: 'category.course-about.course-intro.wishlist.wishlist-btn',
    defaultMessage: 'Wishlist',
    description: 'Label for the button that adds a course to the wishlist.',
  },
  wishlistedBtn: {
    id: 'category.course-about.course-intro.wishlist.wishlisted-btn',
    defaultMessage: 'Wishlisted',
    description: 'Label for the button once a course is on the wishlist, offering to remove it.',
  },
});

export default messages;
